export default __webpack_public_path__ + "static/cooling_towers_w.74cbf8953d9ed1f43f6049f2cadef200.svg";